import React from "react";
import { BannerPreview } from "./Preview";
import { BannerTable } from "../../../Common/BannerTable";
import { DeleteModal } from "../../../Common/DeleteModal";

export function Banner({ deviceType, setDeviceType }: any) {
    return (
        <div
            className="d-grid__clz"
            style={{
                gridTemplateRows: "0.7fr 1.6fr",
                gap: "10px",
            }}
        >
            <BannerPreview deviceType={deviceType} section={"Bannier"} />
            <div
                style={{
                    overflow: "scroll",
                    height: "700px",
                    paddingBottom: "320px",
                    minHeight: "700px",
                }}
            >
                <BannerTable
                    deviceType={deviceType}
                    setDeviceType={setDeviceType}
                    section="Bannier"
                    path={[
                        "template",
                        "SiteWeb",
                        "LaindingPage",
                        "Bannier",
                        deviceType,
                    ]}
                    sizeMobile="480*410 (png,jpg,jpeg ou webp)"
                    sizeDesktop="1920*550 (png,jpg,jpeg ou webp)"
                />
            </div>

            <DeleteModal section="Bannier" />
        </div>
    );
}
